import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { App } from './app/App';
import { router } from './app/router/router';
import { apolloClient } from './shared/api/apolloClient';
import './shared/i18n/i18n';
import './shared/styles/globals.css';
import { applyTheme, useThemeStore } from './stores/themeStore';

applyTheme(useThemeStore.getState().mode);
useThemeStore.subscribe((state) => applyTheme(state.mode));

const root_el = document.getElementById('root');
if (!root_el) throw new Error('#root not found');

createRoot(root_el).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App>
        <RouterProvider router={router} />
      </App>
    </ApolloProvider>
  </React.StrictMode>,
);

// Fade out the pre-React boot splash (index.html) once React has painted its own
// UI — by then a route-level SplashScreen (RequireAuth, RequireCustomerAuth) is
// already showing if a bootstrap check is still in flight, so the handoff is
// seamless. Double rAF waits for the actual paint, not just the React commit.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash_el = document.getElementById('app-splash');
    if (!splash_el) return;
    splash_el.dataset.hidden = 'true';
    setTimeout(() => splash_el.remove(), 400);
  });
});
